import React from 'react'
import style from './Logo.module.scss'
const AshmanovLogo = () => (
  <svg
    className={style.logoBox}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 150"
  >
    <title>Ashmanov.net</title>
    <circle className={style.logoSvg} cx="64.44" cy="65.12" r="18" />
    <path
      className={style.logoSvg}
      d="M64.74,47.13c9.69,1,8.16-2.43,6.46-5.92L82,47.5c-4-.38-7,2.66-2,8.53Z"
    />
    <path
      className={style.logoSvg}
      d="M46.88,69.06C43.7,54.88,36.55,52.55,26.38,54.83l9.39-16.77c3.37,9.86,9.1,14.73,22.85,10Z"
    />
    <circle className={style.logoSvg} cx="14.56" cy="70.21" r="12.91" />
    <path
      className={style.logoSvg}
      d="M27.4,68.84c.73,6.92,5.29,7.89,8.85,6.3l-4,8.57c-1.06-3.76-4.72-6.63-10.51-2.77Z"
    />
    <circle className={style.logoSvg} cx="39.2" cy="81.75" r="7.24" />
    <circle className={style.logoSvg} cx="23.56" cy="42.23" r="12.91" />
    <circle className={style.logoSvg} cx="18.76" cy="101.6" r="10.66" />
    <circle className={style.logoSvg} cx="50.12" cy="99.74" r="7.04" />
    <path
      className={style.logoSvg}
      d="M56.43,96.61c2.22,4.49,6.88,6.31,11.8,1.5L66,108.59c-2.54-6.4-7.53-6.62-11.39-3.42Z"
    />
    <path
      className={style.logoSvg}
      d="M52.09,106.5c-2.1.61-3.68,3.93-.13,6.68l-10.44-3c4.47-.48,4.85-4.13,3.38-5.75Z"
    />
    <circle className={style.logoSvg} cx="93.97" cy="58.67" r="7.04" />
    <circle className={style.logoSvg} cx="43.08" cy="124.64" r="14.5" />
    <circle className={style.logoSvg} cx="75" cy="105.02" r="9.68" />
    <circle className={style.logoSvg} cx="79.3" cy="135.63" r="13.02" />
    <path
      className={style.logoSvg}
      d="M87.33,125.38c3,2.35,8.85-.43,7.35-5.67l5.6,8.85c-4.1-3.6-9.11.48-8.27,4.21Z"
    />
    <circle className={style.logoSvg} cx="112.55" cy="114.61" r="18.58" />
    <path
      className={style.logoSvg}
      d="M95.26,107.8c3.43-8.7-1.3-12.65-6.41-13l10.6-8.17c-1,5,1.63,10.6,10.91,9.5Z"
    />
    <circle className={style.logoSvg} cx="89.47" cy="84.68" r="10.17" />
    <circle className={style.logoSvg} cx="125.76" cy="70.11" r="22.59" />
    <circle className={style.logoSvg} cx="112.55" cy="29.69" r="16.04" />
    <path
      className={style.logoSvg}
      d="M97,33.4C93.87,20.45,87.31,19.12,79.25,21L86.19,7.58c3.11,7.68,8,12.25,20.34,7.25Z"
    />
    <circle className={style.logoSvg} cx="79.99" cy="38.52" r="9.19" />
    <circle className={style.logoSvg} cx="48.4" cy="21.3" r="13.3" />
    <circle className={style.logoSvg} cx="76.94" cy="11.33" r="9.98" />
  </svg>
)

export default AshmanovLogo
